"use client";

import { useBreakpoint } from "@/app/hooks/useBreakpoint";
import { FlightClassWithTravellers } from "./FlightClassWithTravellers/FlightClassWithTravellers";
import { FlightFields } from "./FlightFields/FlightFields";
import FlightTypeDropdown from "./FlightTypeDropdown";
import { useSearchFlights } from "./useSearchFlights";

const SearchFlightsWidget = () => {
  const breakpoint = useBreakpoint();
  const isFullScreenModal = !breakpoint || breakpoint === "sm";

  const {
    values,
    handleAddDestination,
    handleRemoveDestination,
    handleChangeFlightType,
    handleClearAll,
    setValues,
    updateFlightField,
    buildFlightSearchPayload,
  } = useSearchFlights();

  return (
    <div className="p-3 pt-4 md:px-8 md:pt-5 md:pb-8 bg-white dark:bg-dark rounded-2xl border-2 bg-clip-padding border-sleap-white-faint/20">
      <div className="flex flex-col gap-2 mb-2 md:mb-4 sm:flex-row sm:items-center">
        <FlightTypeDropdown
          value={values.flightType}
          onChange={handleChangeFlightType}
          className="sm:w-1/3 md:w-auto"
          isFullScreenModal={isFullScreenModal}
        />
        <FlightClassWithTravellers
          values={values}
          className="sm:w-2/3 md:w-auto"
          setValues={setValues}
          isFullScreenModal={isFullScreenModal}
        />
      </div>
      <FlightFields
        values={values}
        onAddDestination={handleAddDestination}
        onRemoveDestination={handleRemoveDestination}
        onClearAll={handleClearAll}
        updateFlightField={updateFlightField}
        buildFlightSearchPayload={buildFlightSearchPayload}
      />
    </div>
  );
};

export default SearchFlightsWidget;
